import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  required,
  SaveButton,
  Toolbar,
} from "react-admin";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

function CreateToolbar() {
  const navigate = useNavigate();
  return (
    <Toolbar sx={{ gap: 1 }}>
      <SaveButton />
      <Button onClick={() => navigate(-1)}>Annulla</Button>
    </Toolbar>
  );
}

export function ModelCreate() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const projectId = params.get("project_id") ?? undefined;

  return (
    <Create redirect="edit">
      <SimpleForm defaultValues={{ project_id: projectId }} toolbar={<CreateToolbar />}>
        <ReferenceInput source="project_id" reference="projects">
          <SelectInput
            optionText="name"
            label="Progetto"
            validate={[required()]}
            fullWidth
          />
        </ReferenceInput>
        <TextInput
          source="name"
          label="Nome modello"
          validate={[required()]}
          fullWidth
        />
        <TextInput
          source="description"
          label="Descrizione"
          multiline
          rows={4}
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
}
